<template>
  <b-card class="mb-0 mt-1 pb-1" v-if="!isWidthMobile">
    <el-select
      size="mini"
      filterable
      v-model="$store.state.picker.current">
      <el-option v-for="option in items"
                 class="select-default"
                 :value="option['@id']"
                 :label="getLabel(option)"
                 :key="option['@id']">
      </el-option>
    </el-select>
    <div class="btn-group ml-2">
      <button :disabled="!canGoPrev" v-b-tooltip.hover type="button" class="btn btn-link fa fa-arrow-left fa-lg" aria-hidden="true"  @click="goPrev()" ></button>
      <button :disabled="!canGoNext" v-b-tooltip.hover type="button" class="btn btn-link fa fa-arrow-right fa-lg"  aria-hidden="true"  @click="goNext()" ></button>
    </div>
  </b-card>
</template>

<script>
import ApiService from '@/utils/ApiService'
// import getIdFromLink from '@/utils/getIdFromLink'

export default {
  name: 'Picker',
  data () {
    return {
      items: [],
      baseParams: {
        pagination: false
      }
    }
  },
  computed: {
    isWidthMobile () {
      return false
    },
    currentId () {
      return this.$store.state.picker.current
    },
    currentIdIndex () {
      return this.items.map(entry => {
        return entry['@id']
      }).indexOf(this.currentId)
    },
    canGoPrev () {
      return !((this.currentIdIndex) < 1)
    },
    canGoNext () {
      return !((this.currentIdIndex + 1) >= this.items.length)
    }
  },
  watch: {
    '$route.path': {
      immediate: true,
      handler () {
        this.items = []
        this.getItems(this.route, this.params)
      }
    }
  },
  props: {
    route: {
      type: String,
      required: true
    },
    params: {
      type: Object,
      required: false,
      default () {
        return {}
      }
    }
  },
  methods: {
    // TODO: sparametryzować label tak by można było przekazać w propsach
    getLabel (option) {
      if (option.name && option.name.length > 0) {
        if (option.surname && option.surname.length > 0) {
          return option.name + ' ' + option.surname
        }
        return option.name
      } else if (option.firmname1 && option.firmname1.length > 0) {
        return option.firmname1
      } else {
        return ''
      }
    },
    async getItems (route, params) {
      Object.assign(this.baseParams, params)
      this.isLoading = true
      const response = await new ApiService(route, this.baseParams).getResults()
      this.isLoading = false
      this.items = response.items
      if (!Object.keys(params).includes('isCompany')) {
        this.items.push({
          '@id': null,
          firmname1: this.$t('global.all')
        })
      }
    },
    goPrev () {
      if (this.canGoPrev) {
        this.$store.state.picker.current = this.items[this.currentIdIndex - 1]['@id']
      }
    },
    goNext () {
      if (this.canGoNext) {
        this.$store.state.picker.current = this.items[this.currentIdIndex + 1]['@id']
      }
    }
  }
}
</script>
